import Modal from "@common/Modal";
import { useEffect, useState } from "react";

type DestinationCountryPopupProps = {
    isOpen: boolean;
    onClose: () => void;
    selectedCountries: any[];
    onSave: (countries: any[]) => void;
};

const getCountryLabel = (country: any) => String(country?.label || "");

const getCountryKey = (country: any) => String(country?.value ?? country?.id ?? country?.country_id ?? getCountryLabel(country));

export default function DestinationCountryPopup({
    isOpen,
    onClose,
    selectedCountries,
    onSave,
}: DestinationCountryPopupProps) {
    const [popupCountries, setPopupCountries] = useState<any[]>(selectedCountries);

    useEffect(() => {
        if (!isOpen) return;

        setPopupCountries(selectedCountries);
        document.body.classList.add("overflow-hidden");

        const handleEscape = (event: KeyboardEvent) => {
            if (event.key === "Escape") onClose();
        };

        document.addEventListener("keydown", handleEscape);

        return () => {
            document.body.classList.remove("overflow-hidden");
            document.removeEventListener("keydown", handleEscape);
        };
    }, [isOpen, onClose, selectedCountries]);

    const removeCountry = (country: any) => {
        const countryKey = getCountryKey(country);
        setPopupCountries((currentCountries) => currentCountries.filter((item: any) => getCountryKey(item) !== countryKey));
    };

    const handleSave = () => {
        onSave(popupCountries);
        onClose();
    };

    return (
        <div className="model-outer travel-destination-country-popup">
            <Modal show={isOpen} handleClose={onClose}>
                <div className="travel-destination-popup">
                    <div className="travel-destination-popup-head">
                        <h2 className="heading-h2">Destination Country</h2>
                    </div>

                    <div className="travel-destination-popup-body">
                        {popupCountries.map((country: any) => (
                            <button
                                type="button"
                                className="travel-destination-chip"
                                key={getCountryKey(country)}
                                onClick={() => removeCountry(country)}
                            >
                                <span>{getCountryLabel(country)}</span>
                                <i className="ic-clearclose"></i>
                            </button>
                        ))}
                    </div>

                    <div className="travel-destination-popup-footer">
                        <button type="button" className="btn-primary" onClick={handleSave}>
                            Okay
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
